import React, { useState, useMemo } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { getTheme } from "./theme/theme";

import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";

// Pages
import Home from "./pages/Home";
import About from "./components/sections/About";
import Services from "./components/sections/Services";
import Careers from "./components/sections/Careers";
import Contact from "./components/sections/Contact";
import HexagonBackground from "./components/layout/HexagonBackground";

function App() {
  const [mode, setMode] = useState("light");

  const theme = useMemo(() => getTheme(mode), [mode]);

  const toggleTheme = () => setMode(prev => (prev === "light" ? "dark" : "light"));

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {/* <HexagonBackground mode={mode} />  🌟 Background now adapts to theme */}
      <Router>
        <Header mode={mode} toggleTheme={toggleTheme} />
        <Routes>
          <Route path="/" element={<Home mode={mode} />} />
          <Route path="/about" element={<About  mode={mode}/>} />
          <Route path="/services" element={<Services  mode={mode}/>} />
          <Route path="/careers" element={<Careers mode={mode}/>} />
          <Route path="/contact" element={<Contact mode={mode}/>} />
        </Routes>
        <Footer mode={mode} />
      </Router>
    </ThemeProvider>
  );
}

export default App;
